module.exports = __webpack_public_path__ + "img/gary.cd56489d.jpg";